import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  verifyBeforeUpdateEmail,
} from "firebase/auth";
import { auth, db } from "../config/firebase";
import { doc, setDoc, updateDoc } from "@firebase/firestore";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { getAuth, updateProfile } from "firebase/auth";
import store from "../store/store";
import { userState } from "../store/slices/loginSlice";

const useUser = () => {
  const updateUserProfile = async (userinfo) => {
    const {
      displayName,
      birthdate,
      paymentAddress,
      sex,
      uid,
      email,
      newEmail,
      password,
    } = userinfo;
    const updatedInfos = {};
    if (displayName !== undefined) {
      updatedInfos.displayName = displayName;
    }
    if (birthdate !== undefined) {
      updatedInfos.birthdate = birthdate;
    }
    if (paymentAddress !== undefined) {
      updatedInfos.paymentAddress = paymentAddress;
    }
    if (sex !== undefined) {
      updatedInfos.sex = sex;
    }
    if (newEmail !== undefined) {
      updatedInfos.email = newEmail;
      // TODO(you): prompt the user to re-provide their sign-in credentials
      const credential = EmailAuthProvider.credential(email, password);
      await reauthenticateWithCredential(auth.currentUser, credential);
      await verifyBeforeUpdateEmail(auth.currentUser, newEmail);
      await updateDoc(doc(db, "users", uid), {
        ...updatedInfos,
      });
      await auth.signOut();
    } else if (Object.keys(updatedInfos).length) {
      await updateDoc(doc(db, "users", uid), {
        ...updatedInfos,
      });
      const usr = store.getState().login.user;
      store.dispatch(userState({ ...usr, ...updatedInfos }));
    }
  };

  const updateUser = async (userID, value) => {
    await setDoc(
      doc(db, "users", userID),
      { ...value },
      {
        merge: true,
      }
    );
  };

  const uploadProfilePic = async (file, userId) => {
    const auth = getAuth();
    const storage = getStorage();

    const uplaodRef = ref(storage, `images/profileUploads/${userId}.jpg`);
    await uploadBytes(uplaodRef, file);
    const downloadUrl = await getDownloadURL(uplaodRef);
    await updateProfile(auth.currentUser, {
      photoURL: downloadUrl,
    });
    return downloadUrl;
  };

  return {
    updateUserProfile,
    updateUser,
    uploadProfilePic,
  };
};

export default useUser;
